import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import constant from 'src/app/app.constant';
import { MustMatch, passwordValidator } from 'src/app/shared/validators/passwordMatch';
import { CommonHttpService } from 'src/app/utils/common-http.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordFormGroup: FormGroup;
  @Input() userData: any;
  reqdata: any;
  submitted: boolean = false;
  isPasswordVisible: boolean = false;

  constructor(private _formBuilder: FormBuilder, private http: CommonHttpService, private toaster: ToastrService, public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
    this.resetPasswordFormGroup = this._formBuilder.group({
      password: [null, [Validators.required, Validators.minLength(8), passwordValidator]],
      cnfPassword: [null, Validators.required],
    },
      {
        validator: MustMatch('password', 'cnfPassword')
      });
    if (this.userData) {
      this.reqdata = {
        user_id: this.userData?.user_id,
        under_user_id: this.userData?.under_user_id,
        agency_user_id: this.userData?.agency_user_id,
        master_agency_user_id: this.userData?.master_agency_user_id,
        vendor_agency_user_id: this.userData?.vendor_agency_user_id,
        under_role_id: this.userData?.under_role_id,
      }
    }
  }

  resetPassword() {
    this.submitted = true;
    if (this.resetPasswordFormGroup.valid) {
      this.reqdata.password = this.resetPasswordFormGroup.value.password;
      this.reqdata.cnfPassword = this.resetPasswordFormGroup.value.cnfPassword;
      this.http.updateData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.User.Update, this.reqdata).subscribe((response: any) => {
        if (response.status) {
          this.toaster.success('Successfully Updated');
          this.submitted = false;
          this.activeModal.dismiss();
          this.resetPasswordFormGroup.reset();
        } else {
          this.submitted = false;
          this.toaster.error(response.message);
        }
      });
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
